angular.module('employerWebsitePagesModule', ['cacheManagerModule'])
    .service('employerWebsitePagesService', ['$q', 'cacheManagerService', employerWebsitePagesService])
    .controller('employerWebsitePagesController', ['$scope', '$q', '$sce', 'employerWebsitePagesService',
        employerWebsitePagesController]);